import { ShippingAddressInfo } from 'modules/registerPage/components/common/RegistrationUser';
import { ContactPerson } from './ContactPerson';
import { TelephoneNumber } from './TelephoneNumber';

export type User = {
  firstName: string;
  lastName: string;
  partnerName: string;
  birthDate: string;
  birthPlaceName: string;
  birthCountry: string;
  gender: string;
  contactPersonName: string;
  contactPersonPhone: TelephoneNumber;
  country: string;
  placeName: string;
  postalCode: string;
  street: string;
  houseNumber?: string;
  email: string;
  oib: string;
  phone: TelephoneNumber;
  entityTypeCode: string;
  entityType: string;
  shippingCountry: string;
  shippingHouseNumber?: string;
  shippingStreet: string;
  shippingPlaceName: string;
  shippingPostalCode: string;
};

export enum TfaTypes {
  GOOGLE_AUTHENTICATOR = 'GOOGLE_AUTHENTICATOR',
  MAIL = 'MAIL',
}

export type UserLoginDto = {
  typeTfa: TfaTypes;
  tfaSetupRequired?: boolean;
  qrCode?: string;
};

export interface UpdateUserData extends ShippingAddressInfo, ContactPerson {}
